'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = {
  Checkbox: {
    height: '21px',
    width: '21px',
    marginRight: '5px',
    marginLeft: '13px'
  },
  label: {
    fontFamily: 'inherit'
  }
};
class CustomCheckbox extends _react.PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    const default_value = props['default-value'] === undefined ? false : props['default-value'];
    props.onChange({
      e: null,
      value: [true, 'true'].includes(default_value),
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    const {
      checked,
      name
    } = e.target;
    props.onChange({
      e: e,
      value: checked,
      name: name,
      source: 'native'
    });
  };
  render() {
    const component = this,
      props = this.props;
    let class_name = props.className || '';
    if (props['full-width'] === undefined || props['full-width'] === true) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    const status = (props.status || {})[props.name];
    const error_msg = status?.error ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
      error: true,
      className: "form-element-error"
    }, status.error) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name
    }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      label: props.label,
      classes: {
        label: props.classes.label
      },
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        onChange: component.handleChange,
        name: props.name,
        className: props.classes.Checkbox,
        checked: [true, 'true'].includes(props.value),
        color: "primary",
        icon: /*#__PURE__*/_react.default.createElement(_CheckBoxOutlineBlank.default, null),
        id: props.id,
        disabled: props.disabled
      })
    }), error_msg);
    return output;
  }
}
var _default = exports.default = (0, _styles.withStyles)(styles)(CustomCheckbox);
